import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class AxiosRequestController extends BaseModel {
  url: string;
  method: string;
  controller: AbortController;

  constructor(model: AxiosRequestController) {
    super();

    this.url = model.url;
    this.method = model.method;
    this.controller = model.controller;
  }
}
